// ColorBar.js
import React from 'react';

const ColorBar = ({ sliderBackground }) => {
  return (
    <div style={{ ...styles.bar, background: sliderBackground }} />
  );
};

const styles = {
  bar: {
    width: '90%',
    height: '20px',
    marginTop: '10px',
    borderRadius: '5px',
  },
};

export default ColorBar;